import {
    Buildings, Users, Clock, UserCheck, Stack, Wallet, MapTrifold, ClipboardText,
    Broom, HardHat, Truck, Storefront, Package, ForkKnife, ShieldCheck, FirstAid,
    GraduationCap, Exam, Code, WifiHigh, Bank, Bank as Gov, Confetti, ShoppingCart,
    Lightning, Mountains, Airplane, Train, Robot, Cpu, Factory, PhoneCall,
    Headset, ChatCircleText, Envelope, MagnifyingGlass, ChartLineUp, Handshake,
    Gauge, Ruler, PaintRoller, Wrench, TreeStructure, CheckCircle,
} from "@phosphor-icons/react";

export const site = {
    name: "FRONTX Integrated Services India Private Limited",
    shortName: "FRONTX",
    tagline: "Integrated Manpower & Construction Solutions",
    website: "www.frontx.in",
    websiteUrl: "https://www.frontx.in",
    cin: "U41001UP2026PTC249030",
    type: "Private Limited Company",
    coverage: "PAN India",
    // Contact details — phone/whatsapp not set yet (update anytime)
    phone: "",
    phoneRaw: "",
    whatsapp: "",
    email: "admin@frontx.in",
    careersEmail: "admin@frontx.in",
    address: "Uttar Pradesh, India",
    mapQuery: "Uttar Pradesh India",
    logo: "/frontx-logo.png",
};

export const nav = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Services", to: "/services" },
    { label: "Industries", to: "/industries" },
    { label: "Construction", to: "/construction" },
    { label: "Manpower", to: "/manpower-solutions" },
    { label: "Why FRONTX", to: "/why-frontx" },
    { label: "Careers", to: "/careers" },
    { label: "Contact", to: "/contact" },
];

export const images = {
    heroWorkforce: "https://images.unsplash.com/photo-1577199001468-44c049e7603f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    corporate: "https://images.unsplash.com/photo-1758599543116-4fdb887911a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    officeTeam: "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    construction: "https://images.pexels.com/photos/32826199/pexels-photo-32826199.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    constructionSite: "https://images.unsplash.com/photo-1632201147654-f6f54427e538?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    warehouse: "https://images.unsplash.com/photo-1586528116022-aeda1613c63d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    bpo: "https://images.pexels.com/photos/7709224/pexels-photo-7709224.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    manufacturing: "https://images.unsplash.com/photo-1581091212991-8891c7d4bd9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    healthcare: "https://images.pexels.com/photos/6129870/pexels-photo-6129870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    careers: "https://images.unsplash.com/photo-1551135049-8a33b5883817?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const stats = [
    { icon: MapTrifold, value: "PAN India", label: "Operations", sub: "Workforce & projects across India" },
    { icon: Buildings, value: "20+", label: "Industries Served", sub: "Multi-industry workforce solutions" },
    { icon: Users, value: "Bulk & Volume", label: "Hiring Capability", sub: "Large-scale deployment" },
    { icon: ClipboardText, value: "Project-Based", label: "Deployment", sub: "Time-bound workforce teams" },
];

export const aboutFocus = [
    "Reliable manpower deployment",
    "Quality workforce",
    "Timely project execution",
    "Operational support",
    "Compliance-oriented processes",
    "Scalable staffing solutions",
    "Construction project support",
    "PAN India service capability",
];

export const services = [
    {
        id: "contract-staffing", letter: "A", title: "Contract Staffing", icon: UserCheck,
        desc: "Workforce on contractual and project-based requirements.",
        items: ["Skilled Workforce", "Semi-Skilled Workforce", "Unskilled Workforce", "Supervisors", "Field Staff", "Back Office Staff", "Operational Staff"],
        image: images.corporate,
    },
    {
        id: "temporary-staffing", letter: "B", title: "Temporary Staffing", icon: Clock,
        desc: "Manpower for seasonal, short-term and peak requirements.",
        items: ["Seasonal Requirements", "Short-term Projects", "Events", "Surveys", "Examination Projects", "Peak Business Periods", "Temporary Workforce"],
        image: images.warehouse,
    },
    {
        id: "permanent-recruitment", letter: "C", title: "Permanent Recruitment", icon: Users,
        desc: "End-to-end recruitment support for permanent employees.",
        items: ["Sourcing", "Screening", "Interview Coordination", "Selection", "Onboarding Support"],
        image: images.officeTeam,
    },
    {
        id: "bulk-hiring", letter: "D", title: "Bulk & Volume Hiring", icon: Stack,
        desc: "Large-scale recruitment and deployment across multiple locations.",
        items: ["Multi-location Hiring", "Volume Recruitment", "Rapid Deployment", "Dedicated Sourcing Teams"],
        image: images.manufacturing,
    },
    {
        id: "payroll", letter: "E", title: "Payroll Management", icon: Wallet,
        desc: "Payroll and workforce administration for deployed employees.",
        items: ["Salary Processing", "Statutory Compliance", "Attendance Integration", "Workforce Administration"],
    },
    {
        id: "onsite-management", letter: "F", title: "On-Site Workforce Management", icon: MapTrifold,
        desc: "On-ground coordination, attendance monitoring and supervision.",
        items: ["Attendance Monitoring", "Supervision", "Operational Support", "Coordination"],
    },
    {
        id: "project-staffing", letter: "G", title: "Project-Based Staffing", icon: ClipboardText,
        desc: "Complete workforce teams for projects with defined timelines.",
        items: ["Dedicated Teams", "Defined Timelines", "Milestone Deployment", "Scalable Ramp-up"],
    },
    {
        id: "facility-management", letter: "H", title: "Facility Management Support", icon: Broom,
        desc: "Housekeeping, facility, maintenance and operational workforce.",
        items: ["Housekeeping", "Facility Support", "Maintenance Support", "Operational Workforce"],
    },
];

export const manpowerTiers = [
    {
        title: "Unskilled Workforce", icon: HardHat, tone: "navy",
        roles: ["Helpers", "Loaders", "Packers", "Housekeeping Staff", "General Workers", "Construction Helpers", "Warehouse Helpers", "Agricultural Laborers"],
    },
    {
        title: "Semi-Skilled Workforce", icon: Wrench, tone: "blue",
        roles: ["Machine Operators", "Drivers", "Electricians", "Plumbers", "Technicians", "Security Supervisors", "Field Executives", "Warehouse Associates"],
    },
    {
        title: "Skilled & Professional Workforce", icon: GraduationCap, tone: "navy",
        roles: ["Engineers", "Supervisors", "Managers", "IT Professionals", "Healthcare Professionals", "Finance Professionals", "Operations Professionals", "Project Coordinators"],
    },
];

export const industries = [
    { name: "Agriculture", icon: TreeStructure, roles: "Farm Workers, Agricultural Laborers, Dairy Farm Workers, Livestock Caretakers, Poultry Farm Workers, Tractor Operators, Irrigation Technicians, Field Supervisors, Agronomists, Agriculture Officers, Veterinary Assistants, Milk Collection Staff, Feed Plant Workers, Cold Storage Staff, Warehouse Assistants, Packers, Quality Inspectors, Procurement Executives, Field Surveyors, Data Collection Executives, Agriculture Extension Workers, Seed Processing Staff, Fertilizer Plant Workers, Plantation Workers, Harvesting Crew and Nursery Workers." },
    { name: "Construction", icon: HardHat, roles: "Civil Engineers, Site Engineers, Site Supervisors, Masons, Electricians, Plumbers, Welders, Helpers, Safety Officers, Project Coordinators and construction support workforce." },
    { name: "Manufacturing", icon: Factory, roles: "Machine Operators, Production Workers, Quality Inspectors, Technicians, Packers, Store Keepers and Supervisors." },
    { name: "Retail & Trade", icon: Storefront, roles: "Sales Executives, Cashiers, Store Managers, Merchandisers, Customer Service Staff and Inventory Staff." },
    { name: "Logistics & Warehousing", icon: Truck, roles: "Warehouse Associates, Pickers, Packers, Loaders, Inventory Controllers, Dispatch Executives and Drivers." },
    { name: "Hospitality", icon: ForkKnife, roles: "Hotel Staff, Housekeeping Staff, Front Office Executives, Waiters, Chefs, Kitchen Helpers and Guest Relations Staff." },
    { name: "Security Services", icon: ShieldCheck, roles: "Security Guards, Security Supervisors, CCTV Operators, Bouncers, Control Room Operators and Security Support Staff." },
    { name: "Healthcare", icon: FirstAid, roles: "Nurses, Lab Technicians, Pharmacists, Ward Boys, Receptionists, Paramedical Staff and Data Entry Operators." },
    { name: "Education", icon: GraduationCap, roles: "Teachers, Trainers, Academic Coordinators, Counselors, Examination Invigilators and Administrative Staff." },
    { name: "Examination & Assessment", icon: Exam, roles: "Invigilators, Evaluators, Data Entry Operators, Exam Coordinators, Supervisors, Biometric Staff and Frisking Staff." },
    { name: "Information Technology & ITES", icon: Code, roles: "Software Developers, Technical Support Engineers, Helpdesk Engineers, BPO Executives and Data Entry Operators." },
    { name: "Telecommunications", icon: WifiHigh, roles: "Network Engineers, Fiber Technicians, Tower Technicians, Field Executives and Customer Support Staff." },
    { name: "Banking & Financial Services", icon: Bank, roles: "Relationship Managers, Sales Officers, Collection Executives, Customer Service Staff and Back Office Staff." },
    { name: "Government & Public Sector", icon: Gov, roles: "Data Entry Operators, MTS Staff, Administrative Assistants, Field Staff and Project Coordinators." },
    { name: "Facility Management & Housekeeping", icon: Broom, roles: "Housekeeping Staff, Janitors, Facility Supervisors and Maintenance Technicians." },
    { name: "Event Management", icon: Confetti, roles: "Event Coordinators, Registration Staff, Promoters, Hosts, Setup Crew and Crowd Management Staff." },
    { name: "E-commerce", icon: ShoppingCart, roles: "Warehouse Staff, Pickers, Packers, Delivery Executives, Inventory Staff and Customer Support Staff." },
    { name: "Energy & Utilities", icon: Lightning, roles: "Plant Operators, Electricians, Technicians, Maintenance Staff and Control Room Operators." },
    { name: "Mining & Natural Resources", icon: Mountains, roles: "Mine Workers, Equipment Operators, Surveyors, Safety Officers, Welders and Fitters." },
    { name: "Aviation & Airports", icon: Airplane, roles: "Ground Staff, Cargo Handlers, Customer Service Executives, Ramp Staff and Security Personnel." },
    { name: "Railways & Transportation", icon: Train, roles: "Station Staff, Ticketing Staff, Drivers, Conductors, Fleet Supervisors and Operations Staff." },
    { name: "AI & Machine Learning", icon: Robot, roles: "Data Annotators, AI Trainers, Prompt Engineers, AI Quality Analysts and LLM Evaluators." },
    { name: "IT & AI Services", icon: Cpu, roles: "Software Engineers, Cloud Engineers, Cybersecurity Analysts, AI Operations Associates and QA Testers." },
];

export const bpoRoles = [
    { role: "Customer Support Executive", cat: "Customer Support" },
    { role: "Voice Process Executive", cat: "Voice" },
    { role: "Non-Voice Executive", cat: "Non-Voice" },
    { role: "International Voice Agent", cat: "Voice" },
    { role: "Domestic Voice Agent", cat: "Voice" },
    { role: "Chat Support Executive", cat: "Non-Voice" },
    { role: "Email Support Executive", cat: "Non-Voice" },
    { role: "Technical Support Executive", cat: "Technical Support" },
    { role: "Customer Success Executive", cat: "Customer Support" },
    { role: "Process Associate", cat: "Operations" },
    { role: "Senior Process Associate", cat: "Operations" },
    { role: "Team Leader", cat: "Operations" },
    { role: "Assistant Manager – Operations", cat: "Operations" },
    { role: "Operations Manager", cat: "Operations" },
    { role: "Quality Analyst", cat: "Quality" },
    { role: "Quality Manager", cat: "Quality" },
    { role: "Trainer", cat: "Training" },
    { role: "Process Trainer", cat: "Training" },
    { role: "MIS Executive", cat: "MIS" },
    { role: "Workforce Management Executive", cat: "WFM" },
    { role: "Real-Time Analyst", cat: "WFM" },
    { role: "Scheduler", cat: "WFM" },
    { role: "Team Coach", cat: "Training" },
    { role: "Complaint Resolution Executive", cat: "Customer Support" },
    { role: "Escalation Executive", cat: "Customer Support" },
    { role: "Sales Executive", cat: "Sales" },
    { role: "Telecaller", cat: "Sales" },
    { role: "Telesales Executive", cat: "Sales" },
    { role: "Collection Executive", cat: "Sales" },
    { role: "Verification Executive", cat: "Back Office" },
    { role: "Data Entry Operator", cat: "Back Office" },
    { role: "Back Office Executive", cat: "Back Office" },
    { role: "Document Verification Executive", cat: "Back Office" },
    { role: "KYC Executive", cat: "Back Office" },
    { role: "Claims Processing Executive", cat: "Back Office" },
    { role: "Finance & Accounting Executive", cat: "Finance" },
    { role: "HR Recruiter", cat: "Recruitment" },
    { role: "Talent Acquisition Executive", cat: "Recruitment" },
    { role: "Payroll Executive", cat: "Finance" },
    { role: "IT Support Engineer", cat: "Technical Support" },
    { role: "Desktop Support Engineer", cat: "Technical Support" },
    { role: "Network Support Executive", cat: "Technical Support" },
    { role: "Compliance Executive", cat: "Back Office" },
    { role: "Security Officer", cat: "Operations" },
    { role: "Facility Executive", cat: "Operations" },
    { role: "Housekeeping Staff", cat: "Operations" },
    { role: "Office Assistant", cat: "Back Office" },
    { role: "Receptionist", cat: "Back Office" },
];

export const bpoCategories = ["All", "Voice", "Non-Voice", "Sales", "Customer Support", "Back Office", "Technical Support", "Operations", "Quality", "Training", "WFM", "MIS", "Recruitment", "Finance"];

export const constructionGroups = [
    { title: "Civil Construction", icon: Buildings, items: ["Residential Construction", "Commercial Construction", "Industrial Construction", "Institutional Construction", "Building Construction", "Structural Works", "Civil Works"] },
    { title: "Infrastructure Works", icon: MapTrifold, items: ["Roads & Infrastructure Support", "Drainage & Civil Infrastructure", "Site Development", "Earthwork", "Excavation", "Concrete Works", "RCC Works"] },
    { title: "Industrial Construction Support", icon: Factory, items: ["Industrial Site Workforce", "Plant Construction Support", "Fabrication Support", "Installation Support", "Maintenance Workforce", "Skilled Technical Workforce"] },
    { title: "Finishing Works", icon: PaintRoller, items: ["Electrical Works", "Plumbing Works", "Painting", "Flooring", "Masonry", "Carpentry", "False Ceiling", "Interior Finishing"] },
];

export const constructionWorkforce = ["Civil Engineers", "Site Engineers", "Project Managers", "Site Supervisors", "Masons", "Bar Benders", "Shuttering Carpenters", "Electricians", "Plumbers", "Welders", "Fitters", "Helpers", "Safety Officers", "Equipment Operators"];

export const whyFrontx = [
    { title: "PAN India Capability", icon: MapTrifold, desc: "Workforce deployment and project support across multiple locations in India." },
    { title: "Scalable Workforce", icon: Stack, desc: "Ability to support small, medium and large-scale manpower requirements." },
    { title: "Multi-Industry Expertise", icon: Buildings, desc: "Manpower solutions across agriculture, construction, manufacturing, logistics, BPO, IT, healthcare, education, e-commerce and more." },
    { title: "Project-Based Deployment", icon: ClipboardText, desc: "Dedicated manpower solutions for time-bound projects." },
    { title: "Workforce Management", icon: Gauge, desc: "Support for attendance, coordination, supervision and operational workforce management." },
    { title: "Single Integrated Partner", icon: Handshake, desc: "Staffing, manpower and construction services under one organization." },
    { title: "Fast Deployment", icon: Lightning, desc: "Focus on quick sourcing and deployment according to client requirements." },
    { title: "Professional Operations", icon: ShieldCheck, desc: "Structured recruitment, deployment and workforce coordination processes." },
];

export const process = [
    { n: "01", title: "Requirement Analysis", icon: MagnifyingGlass, desc: "Understanding your workforce needs, roles, volume and timelines." },
    { n: "02", title: "Workforce Planning", icon: ClipboardText, desc: "Structured planning of sourcing, skills and deployment strategy." },
    { n: "03", title: "Recruitment & Screening", icon: UserCheck, desc: "Sourcing, screening and shortlisting quality workforce." },
    { n: "04", title: "Documentation & Compliance", icon: ShieldCheck, desc: "Compliance-oriented documentation and verification." },
    { n: "05", title: "Deployment", icon: Truck, desc: "Timely deployment of workforce to your site or project." },
    { n: "06", title: "On-Site Workforce Management", icon: Gauge, desc: "Ongoing supervision, attendance and operational management." },
];

export const careerAreas = ["Field Operations", "Construction", "BPO", "Logistics", "Warehouse", "Sales", "Customer Support", "IT", "AI Data Operations", "Healthcare", "Education", "Facility Management", "Administration"];

export const employmentTypes = ["Contract", "Temporary", "Permanent", "Project-Based", "Bulk / Volume"];
export const projectTypes = ["Residential", "Commercial", "Industrial", "Institutional", "Infrastructure", "Finishing / Interior"];
export const constructionServicesList = ["Civil Construction", "Infrastructure Works", "Industrial Construction Support", "Finishing Works", "Construction Workforce Supply"];

export const industryOptions = industries.map((i) => i.name);

export const iconsRef = { PhoneCall, Headset, ChatCircleText, Envelope, ChartLineUp, Ruler, CheckCircle };
